/* eslint-disable */
export const api = {
  API_URL: process.env.API_URL || 'http://localhost:4000/api/leo/',
  API_AUTH: process.env.AUTH_URL || 'http://localhost:4000/auth/',
  API_TOKEN: process.env.TOKEN_KEY || 'leoleoTokenKey',
};
/* eslint-enable */
